import {
  TranslationConcretingApprovalMessages,
  ConcretingApprovalMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationConcretingApprovalMessages = {
  [ConcretingApprovalMessages.stepDetailsText]: "Details",
  [ConcretingApprovalMessages.stepActionsText]: "Actions",
  [ConcretingApprovalMessages.stepMessagesText]: "Messages",
  [ConcretingApprovalMessages.dialogTitleText]: "Approve Concreting",
  [ConcretingApprovalMessages.dialogButtonSubmitText]: "Confirm",
  [ConcretingApprovalMessages.actionsObservationFieldLabel]: "Observation",
  [ConcretingApprovalMessages.actionsStatusFieldLabel]: "Concreting Status",
  [ConcretingApprovalMessages.concretingRequestStatusApproved]: "Approved",
  [ConcretingApprovalMessages.concretingRequestStatusRejected]: "Rejected",
  [ConcretingApprovalMessages.concretingRequestStatusPending]: "Pending",
  [ConcretingApprovalMessages.messageInputPlaceholder]: "Write a message"
};
